import { useState } from "react";
import Custom from "../../../Components/Buttons/Custom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import WithdrawModal from "./WithdrawModal";
import { displayNumToNum } from "../../../helper/displayNumToNum";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const getPayoutLockTooltip = (row) => {
  const reasons = Array.isArray(row.cannotPayoutBecause)
    ? row.cannotPayoutBecause
    : [];

  if (reasons.length === 1 && reasons[0] === "open_trades") {
    return "برای برداشت،  نباید پوزیشن و سفارش فعالی داشته باشید";
  }

  return "مجاز نیست؛ به قوانین برداشت مراجعه کنید";
};

export default function TableProfit({ payoutData, accLoading }) {
  const navigate = useNavigate();
  const [isWithdrawOpen, setIsWithdrawOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          برداشت سود
        </h3>

        <Custom
          onClick={() => navigate("/rule/withdraw")}
          text="قوانین برداشت"
          href=""
          className="bg-zi-bg2-light dark:bg-zi-bg2-dark !px-5 !py-2 !rounded-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark dark:ring-zi-border-light hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark"
        />
      </div>

      <Table
        isEnglish={[2]}
        columns={[
          { key: "uuid", label: "کد حساب" },
          { key: "accountType", label: "نوع حساب" },
          { key: "accountProfit", label: "سود و زیان حساب" },
          { key: "profitAvailable", label: "سود قابل برداشت" },
          { key: "processTime", label: "زمان تقریبی پردازش" },
          {
            key: "operation",
            label: "برداشت سود",
            render: (value, row) => {
              const isLocked =
                Number(displayNumToNum(row.profitAvailable)) <= 0 ||
                row.role === "trader";
              const tooltipId = `payoutLockReasonTooltip-${row.id}`;

              if (isLocked) {
                return (
                  <div
                    data-tooltip-id={tooltipId}
                    data-tooltip-content={getPayoutLockTooltip(row)}
                    className="w-full flex items-center justify-center gap-2 cursor-default"
                  >
                    <SVG
                      name="lock"
                      classname="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
                    />
                    <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
                      علت
                    </span>
                    <Tooltip
                      id={tooltipId}
                      place="bottom"
                      className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
                    />
                  </div>
                );
              }

              return (
                <TableButton
                  text="درخواست برداشت"
                  svg_name=""
                  svgClassName="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
                  href=""
                  className="!gap-0 !py-1.5 !px-3 !font-thin !w-fit !rounded-md text-zi-text-dark hocus:ring-1 hocus:ring-offset-1 hocus:ring-zi-border-dark bg-zi-gradient-button-blue"
                  onClick={() => {
                    setSelectedRow(row);
                    setSelectedAccount(Number(row.id));
                    setIsWithdrawOpen(true);
                  }}
                />
              );
            },
          },
        ]}
        data={
          payoutData && payoutData.accounts
            ? payoutData.accounts.map((account) => ({
                uuid: account.account_code,
                id: account.account_id,
                role: payoutData.role,
                cannotPayoutBecause: account.cannot_payout_because,
                accountType: `${account.category} | ${account.name}`,
                accountProfit:
                  Number(account.account_pnl) >= 0
                    ? `$${Number(account.account_pnl).toLocaleString()}`
                    : `-$${Number(-1 * account.account_pnl).toLocaleString()}`,
                profitAvailable:
                  account.can_payout && payoutData.role === "trader_verified"
                    ? `$${Number(
                        account.available_for_payout,
                      ).toLocaleString()}`
                    : `$0`,
                processTime: "۷ روز کاری",
                operation: "",
              }))
            : []
        }
      />
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {payoutData &&
        payoutData.accounts &&
        payoutData.accounts.length === 0 && (
          <div className="w-full flex justify-center items-center flex-col gap-5">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              حساب فاندد جهت برداشت سود ندارید
            </p>
            <SVG name="noData" classname="w-24 fill-cyan-500" />
          </div>
        )}
      {isWithdrawOpen && (
        <div
          className="w-full fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setIsWithdrawOpen(false)}
        >
          <div
            className="w-11/12 max-w-2xl flex justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <WithdrawModal
              setIsWithdrawOpen={setIsWithdrawOpen}
              onClose={() => setIsWithdrawOpen(false)}
              data={selectedRow}
              accountId={selectedAccount}
            />
          </div>
        </div>
      )}
    </div>
  );
}
